import {RowsHelper} from "../../helpers/RowsHelper";
import {ProjectsConstants} from "./constants/projectConstants";

/**
 * @typedef {Object} ModelCreate
 * @property {{
 *      id: Number,
 *      parent: Number,
 *      title: String
 * }} selectedRegion - Выбранный регион
 * @property {String} list - Строка с фразами (разделённые переводом строки)
 * @property {String} name - Название задания
 * @property {Number} parsingType - Тип парсинга
 * @property {Number} source - Тип источника
 * @property {{
 *      [ws_type: String]: Boolean,
 * }} frequency
 */

export class DataTransformer
{
    /**
     * Данные для создания задания на парсинг фраз
     * @param {ModelCreate} modelCreate
     * @returns {{
     *      name: String,
     *      regionId: Number,
     *      words: string[],
     *      type: Number,
     * }}
     */
    static payloadCreatePhrases(modelCreate)
    {
        return {
            name: modelCreate.name,
            regionId: modelCreate.selectedRegion.id,
            words: RowsHelper.getArrayFromString(modelCreate.list),
            type: modelCreate.parsingType,
        }
    }

    /**
     * Данные для создания задания на парсинг частотности WS
     * @param {ModelCreate} modelCreate
     * @returns {{
     *      name: String,
     *      regionId: Number,
     *      words: String[],
     *      type: Number,
     *      source: Number,
     *      ws_types: Number[],
     * }}
     */
    static payloadCreateWS(modelCreate)
    {
        return {
            name: modelCreate.name,
            regionId: modelCreate.selectedRegion.id,
            words: RowsHelper.getArrayFromString(modelCreate.list),
            type: modelCreate.parsingType,
            source: modelCreate.source,
            ws_types: Object
                .keys(modelCreate.frequency)
                .filter(key => modelCreate.frequency[key])
                .map(Number),
        }
    }

    /**
     * Данные для создания задания на парсинг частотности Direct
     * @param {ModelCreate} modelCreate
     * @returns {{
     *      name: String,
     *      regionId: Number,
     *      words: String[],
     *      type: Number,
     *      source: Number,
     *      ws_types: Number[],
     *      parse_budget_cpc: Boolean,
     * }}
     */
    static payloadCreateDirect(modelCreate)
    {
        return {
            name: modelCreate.name,
            regionId: modelCreate.selectedRegion.id,
            words: RowsHelper.getArrayFromString(modelCreate.list),
            type: modelCreate.parsingType,
            source: modelCreate.source,
            ws_types: Object
                .keys(modelCreate.frequency)
                .filter(key => modelCreate.frequency[key] && key !== ProjectsConstants.FREQUENCY_TYPE_SWSK)
                .map(Number),
            parse_budget_cpc: modelCreate.parse_budget_cpc,
        }
    }

    /**
     * Данные для обновления проекта
     * @param frequency {{
     *     [ws_type: String]: Boolean,
     * }[]} - частотки
     *
     * @returns {{
     *      ws_types: Number[]
     *      parse_budget_cpc: Boolean,
     * }}
     */
    static payloadUpdate({frequency, parse_budget_cpc})
    {
        return {
            ws_types: Object
                .keys(frequency)
                .filter(key => frequency[key])
                .map(Number),
            parse_budget_cpc: parse_budget_cpc,
        }
    }

    /**
     * Данные для обновления отдельных фраз из таблицы
     * @param words {String[]} - фразы
     * @param parsingType {Number} - тип парсинга частотка/фразы
     * @param frequency {{
     *     [ws_type: String]: Boolean,
     * }[]} - частотки
     * @param parse_budget_cpc?: Boolean, - сбор бюджета, CPC
     *
     * @returns {{
     *      words: String[],
     *      type: number,
     *      ws_types?: Number[],
     *      parse_budget_cpc?: Boolean,
     * }}
     */
    static payloadUpdateWords({words, frequency, parsingType, parse_budget_cpc})
    {
        let payload = {
            words: words,
            type: parsingType,
        }

        if (parsingType === ProjectsConstants.PARSING_TYPE_WS) {
            Object.assign(payload, {
                ws_types: Object
                    .keys(frequency)
                    .filter(key => frequency[key])
                    .map(Number),
                parse_budget_cpc: parse_budget_cpc,
            });
        }

        return payload;
    }
}
